import {
  Component,
  Expressions,
  matchExpression,
  Types,
  Plugins,
} from '@packages/systems/wfdl';
import {EList, Expression} from '@packages/systems/wfdl-ast';
import {getFieldDefaultExpression} from '@packages/systems/core/component-conversions';

const getOverrideFieldKey = matchExpression({
  Select: (val) => {
    if (Expressions.isDataVariable(val.from)) {
      return val.prop;
    }

    return null;
  },
  _: () => null,
});

export const getDefaultForComponentProp = (
  plugins: Plugins.PluginsType,
  component: Component.ComponentType,
  expr: Expression
): Expression => {
  // If we have a data binding that we are unlinking, that prop should
  // be in the current components dataType scope. Find that and get
  // defaultValue based on it.
  const propID = getOverrideFieldKey(expr);
  if (propID) {
    const componentProps = Types.getRecordFields(
      Component.getDataType(component)
    );
    const field = componentProps ? componentProps[propID] : null;
    if (field) {
      return getFieldDefaultExpression(component, propID, field, plugins);
    }
  }
  return EList([]);
};
